// types/experiment.type.ts
var ExperimentActivationEventItems = [
  {
    id: 1,
    title: "On page load",
    value: "page_load",
    selected: true
  }
];
var CommonIgnoredKeys = [
  "created_at",
  "updated_at",
  "started_at",
  "ended_at",
  "created_by",
  "updated_by",
  "started_by",
  "ended_by",
  "status",
  "last_viewed_at"
];

// types/experimentResult.type.ts
var ExperimentResultStatus = /* @__PURE__ */ ((ExperimentResultStatus2) => {
  ExperimentResultStatus2["TOO_EARLY"] = "too_early";
  ExperimentResultStatus2["WINNER_FOUND"] = "winner_found";
  ExperimentResultStatus2["CONTROL_WINS"] = "control_wins";
  ExperimentResultStatus2["INCONCLUSIVE"] = "inconclusive";
  ExperimentResultStatus2["NO_RESULT"] = "no_result";
  return ExperimentResultStatus2;
})(ExperimentResultStatus || {});

// types/platformAuthHandoff.type.ts
var PLATFORM_AUTH_HANDOFF_READY = "prismancy:platform-auth-ready";
var PLATFORM_AUTH_HANDOFF_REQUEST = "prismancy:platform-auth-request";
var PLATFORM_AUTH_HANDOFF_LOGOUT_REQUEST = "prismancy:platform-auth-logout-request";
var PLATFORM_AUTH_HANDOFF_ACK = "prismancy:platform-auth-ack";

// enums/user.enum.ts
var UserRoles = /* @__PURE__ */ ((UserRoles2) => {
  UserRoles2["admin"] = "admin";
  UserRoles2["member"] = "member";
  return UserRoles2;
})(UserRoles || {});

// enums/experiment.enum.ts
var ExperimentStatus = /* @__PURE__ */ ((ExperimentStatus2) => {
  ExperimentStatus2["LIVE"] = "live";
  ExperimentStatus2["DRAFT"] = "draft";
  ExperimentStatus2["ENDED"] = "ended";
  return ExperimentStatus2;
})(ExperimentStatus || {});
var ExperimentType = /* @__PURE__ */ ((ExperimentType2) => {
  ExperimentType2["AB"] = "ab";
  ExperimentType2["REDIRECT"] = "redirect";
  return ExperimentType2;
})(ExperimentType || {});
var StringMatchTypes = /* @__PURE__ */ ((StringMatchTypes2) => {
  StringMatchTypes2["equals"] = "equals";
  StringMatchTypes2["matches"] = "matches";
  StringMatchTypes2["does_not_match"] = "does not match";
  StringMatchTypes2["contains"] = "contains";
  StringMatchTypes2["starts_with"] = "starts with";
  StringMatchTypes2["ends_with"] = "ends with";
  StringMatchTypes2["does_not_equals"] = "does not equals";
  StringMatchTypes2["does_not_contain"] = "does not contain";
  StringMatchTypes2["does_not_start_with"] = "does not start with";
  StringMatchTypes2["does_not_end_with"] = "does not end with";
  return StringMatchTypes2;
})(StringMatchTypes || {});
var NumberMatchTypes = /* @__PURE__ */ ((NumberMatchTypes2) => {
  NumberMatchTypes2["is_greater_than"] = "greater than";
  NumberMatchTypes2["is_less_than"] = "less than";
  NumberMatchTypes2["is_greater_than_or_equal_to"] = "greater than or equals to";
  NumberMatchTypes2["is_less_than_or_equal_to"] = "less than or equals to";
  NumberMatchTypes2["equal"] = "equal";
  NumberMatchTypes2["is_not_equal_to"] = "is not equal to";
  NumberMatchTypes2["between"] = "between";
  return NumberMatchTypes2;
})(NumberMatchTypes || {});
var OptionsMatchTypes = /* @__PURE__ */ ((OptionsMatchTypes2) => {
  OptionsMatchTypes2["matches"] = "matches";
  OptionsMatchTypes2["does_not_match"] = "does not match";
  OptionsMatchTypes2["is"] = "is";
  OptionsMatchTypes2["is_not"] = "is not";
  return OptionsMatchTypes2;
})(OptionsMatchTypes || {});
var DeviceTypes = /* @__PURE__ */ ((DeviceTypes2) => {
  DeviceTypes2["Mobile"] = "Mobile";
  DeviceTypes2["Tablet"] = "Tablet";
  DeviceTypes2["Desktop"] = "Desktop";
  return DeviceTypes2;
})(DeviceTypes || {});
var BrowserTypes = /* @__PURE__ */ ((BrowserTypes2) => {
  BrowserTypes2["Chrome"] = "Chrome";
  BrowserTypes2["Firefox"] = "Firefox";
  BrowserTypes2["Edge"] = "Edge";
  BrowserTypes2["Safari"] = "Safari";
  return BrowserTypes2;
})(BrowserTypes || {});
var ContinentTypes = /* @__PURE__ */ ((ContinentTypes2) => {
  ContinentTypes2["AF"] = "Africa";
  ContinentTypes2["AN"] = "Antarctica";
  ContinentTypes2["AS"] = "Asia";
  ContinentTypes2["EU"] = "Europe";
  ContinentTypes2["NA"] = "North America";
  ContinentTypes2["OC"] = "Oceania";
  ContinentTypes2["SA"] = "South America";
  return ContinentTypes2;
})(ContinentTypes || {});
var OSTypes = /* @__PURE__ */ ((OSTypes2) => {
  OSTypes2["Windows"] = "Windows";
  OSTypes2["Macos"] = "MacOS";
  OSTypes2["Ios"] = "IOS";
  OSTypes2["Android"] = "Android";
  return OSTypes2;
})(OSTypes || {});
var NewVsReturningTypes = /* @__PURE__ */ ((NewVsReturningTypes2) => {
  NewVsReturningTypes2["new"] = "New";
  NewVsReturningTypes2["returning"] = "Returning";
  return NewVsReturningTypes2;
})(NewVsReturningTypes || {});
var CountryTypes = /* @__PURE__ */ ((CountryTypes2) => {
  CountryTypes2["US"] = "United States of America";
  CountryTypes2["CA"] = "Canada";
  CountryTypes2["SG"] = "Singapore";
  return CountryTypes2;
})(CountryTypes || {});
var TimeSuffixTypes = /* @__PURE__ */ ((TimeSuffixTypes2) => {
  TimeSuffixTypes2["s"] = "seconds";
  TimeSuffixTypes2["m"] = "minutes";
  TimeSuffixTypes2["h"] = "hours";
  TimeSuffixTypes2["d"] = "days";
  return TimeSuffixTypes2;
})(TimeSuffixTypes || {});
var AnySelectOptions = /* @__PURE__ */ ((AnySelectOptions2) => {
  AnySelectOptions2["any_of"] = "any of";
  return AnySelectOptions2;
})(AnySelectOptions || {});
var AnyAllSelectOptions = /* @__PURE__ */ ((AnyAllSelectOptions2) => {
  AnyAllSelectOptions2["any_of"] = "any of";
  AnyAllSelectOptions2["all_of"] = "all of";
  return AnyAllSelectOptions2;
})(AnyAllSelectOptions || {});

// enums/change.enum.ts
var ChangeType = /* @__PURE__ */ ((ChangeType2) => {
  ChangeType2["Attribute"] = "attribute";
  ChangeType2["Hide"] = "hide";
  ChangeType2["HTML"] = "html";
  ChangeType2["Link"] = "link";
  ChangeType2["Move"] = "move";
  ChangeType2["Style"] = "style";
  ChangeType2["Text"] = "text";
  return ChangeType2;
})(ChangeType || {});
var ChangeInjectionType = {
  ["attribute" /* Attribute */]: "JS",
  ["hide" /* Hide */]: "CSS",
  ["html" /* HTML */]: "JS",
  ["link" /* Link */]: "JS",
  ["move" /* Move */]: "JS",
  ["style" /* Style */]: "CSS",
  ["text" /* Text */]: "JS"
};
var EditChangeTypeLabels = {
  ["attribute" /* Attribute */]: "Edit Attribute",
  ["hide" /* Hide */]: "Hide Element",
  ["html" /* HTML */]: "Insert HTML",
  ["link" /* Link */]: "Edit Link",
  ["move" /* Move */]: "Move Element",
  ["style" /* Style */]: "Edit Style",
  ["text" /* Text */]: "Edit Text"
};
var ChangeMode = /* @__PURE__ */ ((ChangeMode2) => {
  ChangeMode2["After"] = "after";
  ChangeMode2["Append"] = "append";
  ChangeMode2["Before"] = "before";
  ChangeMode2["Insert"] = "insert";
  return ChangeMode2;
})(ChangeMode || {});
var MoveChangeMode = /* @__PURE__ */ ((MoveChangeMode2) => {
  MoveChangeMode2["After"] = "after";
  MoveChangeMode2["Before"] = "before";
  MoveChangeMode2["Bottom"] = "bottom";
  MoveChangeMode2["Top"] = "top";
  return MoveChangeMode2;
})(MoveChangeMode || {});
var PositionFromChangeMode = {
  ["after" /* After */]: "afterend",
  ["append" /* Append */]: "beforeend",
  ["before" /* Before */]: "beforebegin",
  ["insert" /* Insert */]: "afterbegin"
};
var ChangeAction = /* @__PURE__ */ ((ChangeAction2) => {
  ChangeAction2["Add"] = "add";
  ChangeAction2["Modify"] = "modify";
  ChangeAction2["Remove"] = "remove";
  return ChangeAction2;
})(ChangeAction || {});

// utils/currencyConverter.ts
var convertFromBaseCurrency = (amount, baseCurrency, baseCurrencyRateToUsd, targetCurrency, targetCurrencyRateToUsd = 1) => {
  if (!Number.isFinite(amount)) {
    return 0;
  }
  const effectiveBaseCurrency = baseCurrency?.trim() || "USD";
  const effectiveRate = baseCurrencyRateToUsd && baseCurrencyRateToUsd > 0 ? baseCurrencyRateToUsd : 1;
  if (effectiveBaseCurrency.toUpperCase() === targetCurrency.toUpperCase()) {
    return amount;
  }
  if (effectiveBaseCurrency.toUpperCase() === "USD" && targetCurrency.toUpperCase() === "USD") {
    return amount;
  }
  if (effectiveBaseCurrency.toUpperCase() === "USD") {
    return amount / targetCurrencyRateToUsd;
  }
  if (targetCurrency.toUpperCase() === "USD") {
    return amount;
  }
  const amountInBaseCurrency = amount / effectiveRate;
  const convertedAmount = amountInBaseCurrency * (effectiveRate / targetCurrencyRateToUsd);
  return convertedAmount;
};
var getCurrencyRateToUsd = (currencyCode) => {
  return 1;
};
export {
  AnyAllSelectOptions,
  AnySelectOptions,
  BrowserTypes,
  ChangeAction,
  ChangeInjectionType,
  ChangeMode,
  ChangeType,
  CommonIgnoredKeys,
  ContinentTypes,
  CountryTypes,
  DeviceTypes,
  EditChangeTypeLabels,
  ExperimentActivationEventItems,
  ExperimentResultStatus,
  ExperimentStatus,
  ExperimentType,
  MoveChangeMode,
  NewVsReturningTypes,
  NumberMatchTypes,
  OSTypes,
  OptionsMatchTypes,
  PLATFORM_AUTH_HANDOFF_ACK,
  PLATFORM_AUTH_HANDOFF_LOGOUT_REQUEST,
  PLATFORM_AUTH_HANDOFF_READY,
  PLATFORM_AUTH_HANDOFF_REQUEST,
  PositionFromChangeMode,
  StringMatchTypes,
  TimeSuffixTypes,
  UserRoles,
  convertFromBaseCurrency,
  getCurrencyRateToUsd
};
//# sourceMappingURL=index.mjs.map